module.exports = __webpack_public_path__ + "media/images/follow-agent-b0d5a3cf3e9d1d27dc6aea5f71202ee3.png";